/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Po_Pending_ChangesInputs */

const en_po_pending_changes = /** @type {(inputs: Po_Pending_ChangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Proposals to decide: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Proposals to decide: {count}" |
*
* @param {Po_Pending_ChangesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_pending_changes = /** @type {((inputs: Po_Pending_ChangesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Pending_ChangesInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_pending_changes(inputs)
});